export const ukSizes = [
  '2.5',
  '3',
  '3.5',
  '4',
  '4.5',
  '5',
  '5.5',
  '6',
  '6.5',
  '7',
  '7.5',
  '8',
  '8.5',
  '9',
  '9.5',
  '10',
  '10.5',
  '11',
  '11.5',
  '12',
  '12.5',
  '13',
  '13.5',
  '14',
  '14.5',
  '15',
  '15.5'
];

export const euSizes = [
  '35',
  '35.5',
  '36',
  '36.5',
  '37.5',
  '38',
  '38.5',
  '39',
  '40',
  '40.5',
  '41',
  '42',
  '42.5',
  '43',
  '44',
  '44.5',
  '45',
  '45.5',
  '46',
  '46.5'
];

export const sizeSixVariants = [
  '6(EU-39)',
  '6(EU-40)',
  '6 (EU 39)',
  '6 (EU 40)',
  '6'
];
